export default "__VITE_ASSET__CSivfdri__"